// (function () {
var slidermarque = tns({
  container: "#images-marque",
  controls: true,
  items: 1,
  nav: false,
  mouseDrag: true,
  autoplay: true,
  speed: 1000,
  // center: true,
  // fixedWidth: 100,
  autoplayButtonOutput: false,
  autoplayHoverPause: true,
  controlsText: [
    "<i class='slidenav-left'></i>",
    "<i class='slidenav-right'></i>",
  ],
  responsive: {
    640: {
      //   edgePadding: 20,
      gutter: 30,
      items: 2,
    },
    700: {
      items: 2,
      gutter: 30,
    },
    900: {
      gutter: 30,
      items: 3,
    },
    1000: {
      gutter: 30,
      items: 4,
    },
  },
});
// })();
var sliderHome = tns({
  container: ".slidehome-container",
  //   controls: true,
  // navPosition: "bottom",
  //   controlsContainer: true,
  items: 1,
  autoplay: true,
  speed: 400,
  controlsText: [
    "<i class='slidenav-left'></i>",
    "<i class='slidenav-right'></i>",
  ],
  autoplayButtonOutput: false,
  autoplayHoverPause: true,
  nav: false,
});

var sliderTestinmonials = tns({
  container: "#testimonial-slider",
  controls: false,
  items: 1,
  nav: true,
  navPosition: "bottom",
  center: true,
  mouseDrag: true,
  autoplay: true,
  speed: 2000,
  autoplayButtonOutput: false,
  autoplayHoverPause: true,
  controlsText: [
    "<i class='slidenav-left'></i>",
    "<i class='slidenav-right'></i>",
  ],
  responsive: {
    640: {
      //   edgePadding: 20,
      gutter: 30,
      items: 2,
    },
    700: {
      items: 2,
      gutter: 30,
    },
    900: {
      gutter: 30,
      items: 3,
    },
    1000: {
      gutter: 30,
      items: 3,
    },
  },
});
